<div class="home-book-widget-mobile">
  <ng-container
    *ngIf="bookWidgetFields && bookWidgetAem"
    [ngTemplateOutlet]="viewSearchOptionExpanded ? expandedView : collapsedView"
  ></ng-container>
  <ng-template #collapsedView>
    <div class="flex flex-col gap-24">
      <ng-container [ngTemplateOutlet]="routePickerTemplate"></ng-container>
      <a
        tabindex="0"
        role="button"
        class="link link-sm ml-auto mr-auto"
        (click)="onViewSearchOptionsHandler()"
        (keypress)="$event.key === 'Enter' && onViewSearchOptionsHandler()"
      >
        <span class="link-sort-filter-icon"></span>
        {{ bookWidgetAem.viewSearchOptionsBtn }}
        <span
          [ngClass]="
            viewSearchOptionExpanded
              ? 'link-arrow-icon-expanded'
              : 'link-arrow-icon-collapsed'
          "
        ></span>
      </a>
    </div>
  </ng-template>

  <ng-template #expandedView>
    <div class="flex flex-col gap-24 pb-[150px]">
      <div class="flex flex-col gap-8">
        <ng-container [ngTemplateOutlet]="routePickerTemplate"></ng-container>
        <idp-select-mach-core
          class="h-[64px]"
          [title]="bookWidgetAem.tripTypesField.tripTypeAriaLabel"
          [isTitleHidden]="true"
          [disabled]="bookWidgetFields.tripTypesField.disable"
          [dropdownOptions]="bookWidgetFields.tripTypesField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.tripType
            )
          "
        ></idp-select-mach-core>
        <idp-date-picker-mach-core
          class="min-h-[64px] h-max"
          [selectedTripType]="bookWidgetFields.tripTypesField.selectedTripType"
          [selectedRange]="bookWidgetFields.datesField.dates[0]"
          [bookWidgetAem]="bookWidgetAem"
          [datepickerConfig]="datepickerConfig"
          [fieldErrorInfo]="bookWidgetFields.datesField.fieldErrorInfo?.[0]"
          (selectedDateRange)="
            onDateSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.datesChange,
              0
            )
          "
        ></idp-date-picker-mach-core>
        <idp-select-mach-core
          class="h-[64px]"
          icon="/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg"
          [title]="bookWidgetAem.passengerField.passengerAriaLabel"
          [isTitleHidden]="true"
          [hideDropdownListIcon]="true"
          [disabled]="bookWidgetFields.passengerField.disable"
          [dropdownOptions]="bookWidgetFields.passengerField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.passenger
            )
          "
        ></idp-select-mach-core>
      </div>
      <div class="flex flex-col gap-16">
        <div
          class="flex flex-row items-center justify-between"
          *ngIf="!bookWidgetFields.shopMilesField.hide"
        >
          <label
            for="shopMiles"
            class="mb-0 text-label-md-medium text-static"
            [ngClass]="{
              '!text-disabled': bookWidgetFields.shopMilesField.disable
            }"
          >
            {{ bookWidgetAem.shopMilesField.shopWithMiles }}
          </label>
          <input
            #shopMilesCheckboxElement
            type="checkbox"
            id="shopMiles"
            class="toggle"
            [disabled]="bookWidgetFields.shopMilesField.disable"
            [checked]="bookWidgetFields.shopMilesField.checked"
            (change)="
              onToggleChange($event, bookWidgetFieldUpdateTypes.shopMiles);
              !bookWidgetFields.shopMilesField.checked
                ? analyticsEvent.emit({ el: shopMilesCheckboxElement })
                : false
            "
          />
        </div>
        <div
          class="flex flex-row items-center justify-between"
          *ngIf="!bookWidgetFields.flexDatesField.hide"
        >
          <label
            for="flexDates"
            class="mb-0 text-label-md-medium text-static"
            [ngClass]="{
              '!text-disabled': bookWidgetFields.flexDatesField.disable
            }"
          >
            {{ bookWidgetAem.flexDatesField.flexDates }}
          </label>
          <input
            #flexDatesCheckboxElement
            type="checkbox"
            id="flexDates"
            class="toggle"
            [disabled]="bookWidgetFields.flexDatesField.disable"
            [checked]="bookWidgetFields.flexDatesField.checked"
            (change)="
              onToggleChange($event, bookWidgetFieldUpdateTypes.flexDates);
              !bookWidgetFields.flexDatesField.checked
                ? analyticsEvent.emit({ el: flexDatesCheckboxElement })
                : false
            "
          />
        </div>
        <div
          class="flex flex-row items-center justify-between"
          *ngIf="!bookWidgetFields.basicFaresField.hide"
        >
          <label
            for="basicFaresField"
            class="mb-0 text-label-md-medium text-static"
            [ngClass]="{
              '!text-disabled': bookWidgetFields.basicFaresField.disable
            }"
          >
            {{ bookWidgetAem.includeBasicField.includeBasic }}
          </label>
          <input
            #basicFaresCheckboxElement
            type="checkbox"
            id="basicFaresField"
            class="toggle"
            [disabled]="bookWidgetFields.basicFaresField.disable"
            [checked]="bookWidgetFields.basicFaresField.checked"
            (change)="
              onToggleChange($event, bookWidgetFieldUpdateTypes.basicFares);
              !bookWidgetFields.basicFaresField.checked
                ? analyticsEvent.emit({ el: basicFaresCheckboxElement })
                : false
            "
          />
        </div>
        <div
          class="flex flex-row items-center justify-between"
          *ngIf="!bookWidgetFields.refundableFareField.hide"
        >
          <div class="flex gap-[5px]">
            <label
              for="refundableFares"
              class="mb-0 text-label-md-medium text-static"
              [ngClass]="{
                '!text-disabled': bookWidgetFields.refundableFareField.disable
              }"
            >
              {{ bookWidgetAem.refundableFareField.refundableOnly }}
            </label>
            <img
              class="grayscale-effect"
              src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
              [attr.aria-label]="
                bookWidgetAem.refundableFareField.refundableOnly +
                ' ' +
                bookWidgetAem.helpIconAriaLabel
              "
              role="button"
              tabindex="0"
              data-acdl-action="widget:refundable fares only tooltip click"
              data-acdl-page-section="header:search widget"
              (click)="
                infoIconClickHandler(
                  bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY,
                  $event
                )
              "
              (keypress)="
                $event.key === 'Enter' &&
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY,
                    $event
                  )
              "
            />
          </div>
          <input
            #refundableFaresCheckboxElement
            type="checkbox"
            id="refundableFares"
            class="toggle"
            [disabled]="bookWidgetFields.refundableFareField.disable"
            [checked]="bookWidgetFields.refundableFareField.checked"
            (change)="
              onToggleChange($event, bookWidgetFieldUpdateTypes.refundableFare);
              !bookWidgetFields.refundableFareField.checked
                ? analyticsEvent.emit({ el: refundableFaresCheckboxElement })
                : false
            "
          />
        </div>
      </div>
      <idp-options-expander-mach-core
        class="advance-options-toggle"
        [content]="bookWidgetAem.advancedSearchBtn"
        [isExpanded]="isAdvancedSearchExpanded"
        (expandedEmit)="toggleAdvSearchExpandedEvent.emit()"
        (analyticsEvent)="analyticsEvent.emit({ el: $event })"
      ></idp-options-expander-mach-core>
      <div class="flex flex-col gap-16" *ngIf="isAdvancedSearchExpanded">
        <div
          class="flex flex-row items-center justify-between"
          *ngIf="!bookWidgetFields.flexAirportsField.hide"
        >
          <label
            for="flexAirports"
            class="mb-0 text-label-md-medium text-static"
            [ngClass]="{
              '!text-disabled': bookWidgetFields.flexAirportsField.disable
            }"
          >
            {{ bookWidgetAem.flexAirportsField.flexAirports }}
          </label>
          <input
            #flexAirportsCheckboxElement
            type="checkbox"
            id="flexAirports"
            class="toggle"
            [disabled]="bookWidgetFields.flexAirportsField.disable"
            [checked]="bookWidgetFields.flexAirportsField.checked"
            (change)="
              onToggleChange($event, bookWidgetFieldUpdateTypes.flexAirport);
              !bookWidgetFields.flexAirportsField.checked
                ? analyticsEvent.emit({ el: flexAirportsCheckboxElement })
                : false
            "
          />
        </div>
        <ng-container *ngIf="!bookWidgetFields.bestFareOptionsField.hide">
          <idp-best-fare-options-mach-core
            [title]="bookWidgetAem.bestFareOptionsField.bestFare"
            [disabled]="bookWidgetFields.bestFareOptionsField.disable"
            [infoModalContent]="bookWidgetAem.bestFareOptionsField.infoModal"
            [infoTooltipOptions]="{
              positions: 'top-right',
              color: 'high-contrast',
              triggerEvent: 'hover'
            }"
            [dropdownOptions]="
              bookWidgetFields.bestFareOptionsField.dropdownOptions
            "
            (bestFareOptionsChange)="
              onDropdownSelectionChange(
                $event,
                bookWidgetFieldUpdateTypes.bestFareOptions
              )
            "
          ></idp-best-fare-options-mach-core>
        </ng-container>
        <ng-container *ngIf="!bookWidgetFields.meetingEventCodeField.hide">
          <idp-meeting-code-mach-core
            [placeholder]="bookWidgetAem.meetingEventCodeField.placeholder"
            [title]="bookWidgetAem.meetingEventCodeField.meetingEventCode"
            [value]="
              bookWidgetFields.meetingEventCodeField.meetingEventCodeValue
            "
            [disabled]="bookWidgetFields.meetingEventCodeField.disable"
            [infoModalContent]="bookWidgetAem.meetingEventCodeField.infoModal"
            [errorMessage]="
              bookWidgetFields.meetingEventCodeField.fieldErrorInfo
                ?.errorMessage
            "
            [disclaimerMessage]="
              bookWidgetFields.meetingEventCodeField.disclaimerMessage
            "
            [tooltipOptions]="{
              positions: 'top-right',
              color: 'high-contrast',
              triggerEvent: 'hover'
            }"
            (valueChange)="
              onInputFieldChange(
                $event,
                bookWidgetFieldUpdateTypes.meetingEventCode
              )
            "
          ></idp-meeting-code-mach-core>
        </ng-container>
        <a
          #edocsLinkElement
          *ngIf="!bookWidgetFields.edocsLink.hide"
          [href]="
            bookWidgetFields.edocsLink.disable
              ? ''
              : bookWidgetFields.edocsLink.src
          "
          [ngClass]="
            bookWidgetFields.edocsLink.disable
              ? '!text-disabled pointer-events-none'
              : ''
          "
          class="link link-sm"
          (click)="analyticsEvent.emit({ el: edocsLinkElement })"
        >
          {{ bookWidgetAem.edocsLink }}
        </a>
      </div>
      <div
        class="cta-btn-container fixed bottom-0 left-0 right-0 py-[24px] border-t border-[#AAADBD] bg-surface-02 flex justify-center items-center"
      >
        <button
          id="findFilghtsCta"
          #findFlightButton
          class="button button-primary button-md w-screen max-w-[343px] tablet:max-w-[520px]"
          role="button"
          tabindex="0"
          [attr.aria-label]="bookWidgetAem.searchBtn"
          data-acdl-name="flights:find flights"
          data-acdl-action="flight search initiation:flights search"
          data-acdl-page-section="header:book:flights"
          (click)="onFindFlightClick(findFlightButton)"
          (keypress)="
            $event.key === 'Enter' && onFindFlightClick(findFlightButton)
          "
        >
          {{ bookWidgetAem.searchBtn }}
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #routePickerTemplate>
    <idp-one-way-route-picker-mach-core
      class="min-h-[74px] h-max"
      [routePickerContent]="{
        origin: {
          title: bookWidgetAem.airportsField.from,
          subtitle: bookWidgetAem.airportsField.yourOrigin
        },
        destination: {
          title: bookWidgetAem.airportsField.to,
          subtitle: bookWidgetAem.airportsField.yourDestination
        },
        ariaLabels: {
          origin:
            bookWidgetAem.airportsField.originAriaLabel +
            (bookWidgetFields.airportsField.airports[0].fromAirportcode.length
              ? ' ' +
                bookWidgetFields.airportsField.airports[0].fromAirportcode +
                ', ' +
                bookWidgetFields.airportsField.airports[0].fromCity
              : ''),
          swapArrow: bookWidgetAem.airportsField.swapAriaLabel,
          destination:
            bookWidgetAem.airportsField.destinationAriaLabel +
            (bookWidgetFields.airportsField.airports[0].toAirportcode.length
              ? ' ' +
                bookWidgetFields.airportsField.airports[0].toAirportcode +
                ', ' +
                bookWidgetFields.airportsField.airports[0].toCity
              : '')
        }
      }"
      [routePickerCities]="{
        destinationCode:
          bookWidgetFields.airportsField.airports[0].toAirportcode,
        destinationName: bookWidgetFields.airportsField.airports[0].toCity,
        destinationRegion: '',
        originCode: bookWidgetFields.airportsField.airports[0].fromAirportcode,
        originName: bookWidgetFields.airportsField.airports[0].fromCity,
        originRegion: ''
      }"
      [routePickerError]="
        bookWidgetFields.airportsField.fieldErrorInfo?.routePickerField
      "
      [recentSearchList]="recentSearchList"
      [savedSearchList]="savedSearchList"
      [searchModalTabs]="searchModalTabs"
      [isFullscreen]="isFullscreen"
      [predictiveSearchData]="predictiveSearchData"
      (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
      (swapClicked)="swapClicked.emit(0)"
      (searchModalEvent)="
        searchModalEvent.emit($event); expandSearchView($event)
      "
    ></idp-one-way-route-picker-mach-core>
  </ng-template>
</div>
